import { Expose } from "class-transformer";

export class CreateCurrencyDto {
  @Expose()
  code: string;

  @Expose()
  isoCode: string;

  @Expose()
  label: string;

  @Expose()
  exchangeRate: number;

  @Expose()
  isDefault?: boolean;
}
